import { useMemo } from "react";
import AddPageSubMenu from "src/components/layouts/AddPageSubMenu";
import { createQaSettingsSubMenu } from "src/routing/navigation";

const QaSettingsSubMenu: React.FC = () => {
    const subMenu = useMemo(() => {
        return createQaSettingsSubMenu();
    }, []);

    if (!subMenu) {
        return null;
    }

    return <AddPageSubMenu subMenu={subMenu} />;
};

export default QaSettingsSubMenu;
